<template>
    <div>
        <input type="text" :value="value" @input="update($event)" />
    </div>
</template>

<script>
    export default {
        name: 'v-text-field',
        props:['value', 'field'],
        methods:{
            update(ev){
                this.$emit('input', ev.target.value)
            }
        }
    }
</script>

<style scoped lang="scss">
</style>
